import store from '@/store'
import _ from 'lodash'

/**
 * Access Helper
 *
 * Todo: Load roles and its levels from database
 */

class AvantiAccess {
  constructor () {
    this.roles = {
      'management': 0,
      'accounting': 100,
      'admin': 200,
      'expert': 300,
      'consultant': 350,
      'department': 400,
      'logistic': 400,
      'assistant': 400,
      'photographer': 400,
      'others': 1000
    }
  }

  hasAccess = function (minRole = 'others', exact = false) {
    // Get my role
    const usrRole = _.has(store.getters, 'getUser.rolle.slug')
      ? store.getters.getUser.rolle.slug
      : 'others'

    // Get min access level (or "management" if not found)
    const minAccessLevel = this.roles.hasOwnProperty(minRole) ? this.roles[minRole] : this.roles.management

    // Get usr access level (or "others" if not found)
    const usrAccessLevel = this.roles.hasOwnProperty(usrRole) ? this.roles[usrRole] : this.roles.others

    if (exact) {
      return minAccessLevel === usrAccessLevel
    }

    // Validate so usr access level is less than or equal to min access level
    if (usrAccessLevel <= minAccessLevel) {
      return true
    }

    return false
  }
}

export default new AvantiAccess()



// WEBPACK FOOTER //
// ./src/plugins/access.js